import { Tooltip } from '@mui/material'
import React from 'react'
import HelpIcon from '@mui/icons-material/Help'

interface Props {
  tip: string
}

const HelpTip = (props: Props) => {
  return (
    <Tooltip color='info' title={
      <div style={{ whiteSpace: 'pre-line' }}>{props.tip}</div>
    } sx={{
      width: '18px',
      height: '18px'
    }}>
      <HelpIcon />
    </Tooltip>
  )
}

export default HelpTip
